import { LAYER_TYPES } from '../../../../../lib';
import SVGRoot from '../../../SVGRoot';
import SVGTextRoot from '../../../SVGTextRoot';

/**
 * Picks SVG layer to render by its type
 * @param {String} layerType layer type to render
 * @return {React.Component}
 */
const SVGLayerByType = (layerType) => {
    switch (layerType) {
        case LAYER_TYPES.TEXT:
            return SVGTextRoot;
        default:
            return SVGRoot;
    }
};

export default SVGLayerByType;
